import { CancelTokenSource } from 'axios';

import { Messages } from '../../codegen/Localize';
import { RestApiErrorResponse } from '../../httpClient/RestApiService';
import { UploadFlowStartAction } from '../actions/UploadFlowActions';
import { callViaApiService, FlowUploadResponse, UploadFlowErrorCodes } from '../restApi/FlowUpload';
import { createCancelToken, createRequestBodyBlob, generateBoundaryVal, getContentHeader, getFooter } from './UploadContentRequestHelper';

const FLOW_CONTENT_DISPOSITION_NAME = 'tableau_flow';

function uploadFlowRequest(action: UploadFlowStartAction, projectLuid: string, progressDispatcher: (progress: any) => void, cancelToken: CancelTokenSource): Promise<FlowUploadResponse> {
  const { file, name, description } = action.data;

  const boundaryVal = generateBoundaryVal();
  const requestHeader = getFlowPublishRequestWithHeader(name, description, projectLuid);
  const requestBodyBlob = createRequestBodyBlob(FLOW_CONTENT_DISPOSITION_NAME, boundaryVal, file, requestHeader);
  const queryParams = getQueryParam(action.overwrite);
  const headers = { 'Content-Type': 'multipart/mixed; boundary=' + boundaryVal };

  return callViaApiService(requestBodyBlob, headers, queryParams, progressDispatcher, cancelToken) as Promise<FlowUploadResponse>;
}

function getQueryParam(overwrite: boolean) {
  return {
    'overwrite': overwrite,
  };
}

function getFlowPublishRequestWithHeader(name: string, description: string, projectId: string) {
  const data = {
    'flow': {
      'name': name,
      'description': description,
      'project': { 'id': projectId }
    },
  };

  const dataStr = JSON.stringify(data);

  let payloadStr = 'Content-Disposition: name="request_payload"\r\n';
  payloadStr += 'Content-Type: application/json\r\n';
  payloadStr += `Content-Length: ${dataStr.length}\r\n\r\n`;
  payloadStr += dataStr + '\r\n';

  return payloadStr;
}

function getErrorMessage(response: RestApiErrorResponse): string {
  if (response?.data?.error?.detail?.length > 0) {
    return response.data.error.detail;
  }

  return Messages.flowUploadFailureMessage();
}

function getActionMessage(response: RestApiErrorResponse): string {
  if (response?.data?.error?.code === String(UploadFlowErrorCodes.PUBLISHING_UNAUTHORIZED)) {
    return Messages.goBack();
  }

  return Messages.tryAgain();
}

export default {
  uploadFlowRequest,
  getErrorMessage,
  getActionMessage,
};

export const TestUploadFlowRequestHelper = {
  uploadFlowRequest,
  createRequestBodyBlob,
  getFlowPublishRequestWithHeader,
  getContentHeader,
  getQueryParam,
  getFooter,
  generateBoundaryVal,
  createCancelToken,
  FLOW_CONTENT_DISPOSITION_NAME,
};
